
import React from 'react';

const ProjectCard = ({ project }) => {
    const cardStyle = {
        backgroundColor: 'var(--color-bg-secondary)',
        borderRadius: '20px',
        padding: '2rem',
        marginBottom: '2rem',
        transition: 'transform 0.3s ease',
    };

    return (
        <article style={cardStyle} className="project-card hover-scale">
            <h3 style={{ marginBottom: '0.5rem' }}>{project.title}</h3>
            <p style={{ marginBottom: '1.5rem', fontSize: '0.95rem' }}>{project.description}</p>
            <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', marginBottom: '1.5rem' }}>
                {project.tags.map(tag => (
                    <span key={tag} style={{
                        fontSize: '0.8rem',
                        padding: '4px 10px',
                        borderRadius: '15px',
                        backgroundColor: '#333',
                        color: '#fff'
                    }}>
                        {tag}
                    </span>
                ))}
            </div>
            <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                <a href={project.link} target="_blank" rel="noopener noreferrer" style={{ fontSize: '0.9rem', color: 'var(--color-accent)', fontWeight: '500' }}>
                    View Project &rarr;
                </a>
                {project.githubRepo && (
                    <a href={project.githubRepo} target="_blank" rel="noopener noreferrer" style={{ fontSize: '0.9rem', color: 'var(--color-text-secondary)' }}>
                        Source Code
                    </a>
                )}
            </div>
        </article>
    );
};

export default ProjectCard;
